"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _RulesListContainer = _interopRequireDefault(require("../components/rules-list/RulesListContainer"));
var _SaveCancelFooter = _interopRequireDefault(require("../components/common/SaveCancelFooter"));
var _PageContext = require("../context/PageContext");
var _usePlaybook2 = require("../hooks/usePlaybook");
var _AuthContext = require("../context/AuthContext");
var _webApi = require("../utils/web-api");
var _remedy = require("../utils/remedy");
var _arrowLeft = _interopRequireDefault(require("@assets/arrow-left.svg"));
var _AnalyticsContext = require("../context/AnalyticsContext");
var _toast = require("../utils/toast");
var _select = require("@design/ui/select");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t3 in e) "default" !== _t3 && {}.hasOwnProperty.call(e, _t3) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t3)) && (i.get || i.set) ? o(f, _t3, i) : f[_t3] = e[_t3]); return f; })(e, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var FallbackPage = function FallbackPage(_ref) {
  var isVisible = _ref.isVisible,
    _ref$playbookId = _ref.playbookId,
    playbookId = _ref$playbookId === void 0 ? "" : _ref$playbookId,
    _ref$ruleId = _ref.ruleId,
    ruleId = _ref$ruleId === void 0 ? "" : _ref$ruleId,
    _ref$mode = _ref.mode,
    mode = _ref$mode === void 0 ? 'edit' : _ref$mode,
    fallbackType = _ref.fallbackType,
    fallbackIndex = _ref.fallbackIndex;
  var _usePage = (0, _PageContext.usePage)(),
    showPage = _usePage.showPage,
    pageParams = _usePage.pageParams;
  var _usePlaybook = (0, _usePlaybook2.usePlaybook)(playbookId),
    reload = _usePlaybook.reload,
    playbook = _usePlaybook.playbook;
  var _useAuthInfo = (0, _AuthContext.useAuthInfo)(),
    user = _useAuthInfo.user;
  var authHeader = (0, _AuthContext.useAuthHeader)();
  var _useAnalytics = (0, _AnalyticsContext.useAnalytics)(),
    sendError = _useAnalytics.sendError;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSaving = _useState2[0],
    setIsSaving = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    originalFormData = _useState4[0],
    setOriginalFormData = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isEditMode = _useState6[0],
    setIsEditMode = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    currentRule = _useState8[0],
    setCurrentRule = _useState8[1];
  var _useState9 = (0, _react.useState)({
      name: "",
      description: "",
      remedyType: "edit_section_tracked",
      editContent: "",
      comment: ""
    }),
    _useState0 = _slicedToArray(_useState9, 2),
    formData = _useState0[0],
    setFormData = _useState0[1];
  var resetForm = function resetForm() {
    setFormData({
      name: "",
      description: "",
      remedyType: "edit_section_tracked",
      editContent: "",
      comment: ""
    });
  };
  (0, _react.useEffect)(function () {
    var loadRule = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _iterator, _step, section, foundRule, loadedFormData, comment, editContent, remedyType, names, descriptions, remedies, contexts, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (!(ruleId && playbook !== null && playbook !== void 0 && playbook.bySection)) {
                _context.n = 7;
                break;
              }
              _iterator = _createForOfIteratorHelper(playbook.bySection);
              _context.p = 1;
              _iterator.s();
            case 2:
              if ((_step = _iterator.n()).done) {
                _context.n = 4;
                break;
              }
              section = _step.value;
              foundRule = section.rules.find(function (r) {
                return r.id === ruleId;
              });
              if (!foundRule) {
                _context.n = 3;
                break;
              }
              setCurrentRule(foundRule);
              loadedFormData = void 0;
              if (fallbackType === 'primary') {
                comment = (0, _remedy.getRemedyComments)(foundRule.remedy)[0] || '';
                editContent = (0, _remedy.getEditString)(foundRule.remedy);
                remedyType = (0, _remedy.getRemedyEditsType)(foundRule.remedy);
                loadedFormData = {
                  name: foundRule.remedyName || "",
                  description: foundRule.remedyDescription || "",
                  remedyType: remedyType,
                  editContent: editContent,
                  comment: comment
                };
              } else {
                names = foundRule.alternativeRemedyName || [];
                descriptions = foundRule.alternativeRemedyDescription || [];
                remedies = foundRule.alternativeRemedy || [];
                contexts = foundRule.alternativeRemedyContext || [];
                loadedFormData = {
                  name: names[fallbackIndex] || "",
                  description: descriptions[fallbackIndex] || "",
                  remedyType: "edit_section_tracked",
                  // Default for alternatives
                  editContent: remedies[fallbackIndex] || "",
                  comment: contexts[fallbackIndex] || ""
                };
              }
              setFormData(loadedFormData);
              setOriginalFormData(loadedFormData);
              return _context.a(3, 4);
            case 3:
              _context.n = 2;
              break;
            case 4:
              _context.n = 6;
              break;
            case 5:
              _context.p = 5;
              _t = _context.v;
              _iterator.e(_t);
            case 6:
              _context.p = 6;
              _iterator.f();
              return _context.f(6);
            case 7:
              return _context.a(2);
          }
        }, _callee, null, [[1, 5, 6, 7]]);
      }));
      return function loadRule() {
        return _ref2.apply(this, arguments);
      };
    }();
    loadRule();
  }, [ruleId, playbook === null || playbook === void 0 ? void 0 : playbook.id, fallbackType, fallbackIndex]);
  var canEdit = mode === 'create' || mode === 'edit' && ((currentRule === null || currentRule === void 0 ? void 0 : currentRule.isManagedRule) && (user === null || user === void 0 ? void 0 : user.hasManageManagedRulesPermission) || !(currentRule !== null && currentRule !== void 0 && currentRule.isManagedRule) && (user === null || user === void 0 ? void 0 : user.hasManageUserRulesPermission));
  var getRemedyTypeDisplayText = function getRemedyTypeDisplayText(value) {
    switch (value) {
      case 'edit_section_tracked':
        return 'Edit Section';
      case 'edit_tracked':
        return 'Edit Paragraph';
      case 'edit_document_tracked':
        return 'Edit Document';
      default:
        return 'Default';
    }
  };
  var handleBackClick = function handleBackClick() {
    if (mode === 'create') {
      resetForm();
    }
    // Preserve returnPage from previous navigation
    showPage(_PageContext.PAGES.rulePage, {
      playbookId: playbookId,
      ruleId: ruleId,
      mode: 'edit',
      returnPage: pageParams === null || pageParams === void 0 ? void 0 : pageParams.returnPage
    });
  };
  var handleInputChange = function handleInputChange(field, value) {
    if (!canEdit) return;
    setFormData(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, field, value));
    });
  };
  var handleFieldFocus = function handleFieldFocus() {
    if (canEdit && !isEditMode) {
      setIsEditMode(true);
    }
  };
  var handleSave = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var updatedRule, remedy, names, descriptions, remedies, contexts, models, targets, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            if (formData.name) {
              _context2.n = 1;
              break;
            }
            (0, _toast.toastError)("Please enter a fallback name");
            return _context2.a(2);
          case 1:
            if (currentRule) {
              _context2.n = 2;
              break;
            }
            (0, _toast.toastError)("Rule not found");
            return _context2.a(2);
          case 2:
            setIsSaving(true);
            _context2.p = 3;
            if (fallbackType === 'primary') {
              remedy = (0, _remedy.buildRemedyString)({
                comments: formData.comment,
                editSectionTracked: formData.remedyType === 'edit_section_tracked' ? formData.editContent : null,
                editParagraphTracked: formData.remedyType === 'edit_tracked' ? formData.editContent : null,
                editDocumentTracked: formData.remedyType === 'edit_document_tracked' ? formData.editContent : null,
                commentType: "comment_once"
              });
              updatedRule = _objectSpread(_objectSpread({}, currentRule), {}, {
                remedy: remedy,
                remedyName: formData.name,
                remedyDescription: formData.description
              });
            } else {
              names = _toConsumableArray(currentRule.alternativeRemedyName || []);
              descriptions = _toConsumableArray(currentRule.alternativeRemedyDescription || []);
              remedies = _toConsumableArray(currentRule.alternativeRemedy || []);
              contexts = _toConsumableArray(currentRule.alternativeRemedyContext || []);
              models = _toConsumableArray(currentRule.alternativeRemedyModel || []);
              targets = _toConsumableArray(currentRule.alternativeRemedyTarget || []); // Ensure arrays are large enough
              while (names.length <= fallbackIndex) names.push("");
              while (descriptions.length <= fallbackIndex) descriptions.push("");
              while (remedies.length <= fallbackIndex) remedies.push("");
              while (contexts.length <= fallbackIndex) contexts.push("");
              while (models.length <= fallbackIndex) models.push("gpt-4o");
              while (targets.length <= fallbackIndex) targets.push(null);
              names[fallbackIndex] = formData.name;
              descriptions[fallbackIndex] = formData.description;
              remedies[fallbackIndex] = formData.editContent;
              contexts[fallbackIndex] = formData.comment;
              updatedRule = _objectSpread(_objectSpread({}, currentRule), {}, {
                alternativeRemedyName: names,
                alternativeRemedyDescription: descriptions,
                alternativeRemedy: remedies,
                alternativeRemedyContext: contexts,
                alternativeRemedyModel: models,
                alternativeRemedyTarget: targets
              });
            }
            if (authHeader) {
              _context2.n = 4;
              break;
            }
            return _context2.a(2);
          case 4:
            _context2.n = 5;
            return (0, _webApi.updateRule)(authHeader, ruleId, updatedRule);
          case 5:
            reload();
            setIsEditMode(false);
            showPage(_PageContext.PAGES.rulePage, {
              playbookId: playbookId,
              ruleId: ruleId,
              mode: 'edit',
              returnPage: pageParams === null || pageParams === void 0 ? void 0 : pageParams.returnPage
            });
            _context2.n = 7;
            break;
          case 6:
            _context2.p = 6;
            _t2 = _context2.v;
            console.error("Failed to save fallback:", _t2);
            sendError(_t2, {
              component: "FallbackPage",
              action: 'save_fallback',
              playbookId: playbookId,
              ruleId: ruleId,
              fallbackName: formData.name,
              fallbackType: fallbackType
            });
            (0, _toast.toastError)("Failed to save fallback");
          case 7:
            _context2.p = 7;
            setIsSaving(false);
            return _context2.f(7);
          case 8:
            return _context2.a(2);
        }
      }, _callee2, null, [[3, 6, 7, 8]]);
    }));
    return function handleSave() {
      return _ref3.apply(this, arguments);
    };
  }();
  var handleCancel = function handleCancel() {
    if (originalFormData) {
      setFormData(originalFormData);
    } else if (mode === 'create') {
      resetForm();
    }
    setIsEditMode(false);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "w-full h-full bg-white flex flex-col overflow-hidden",
    "data-sentry-component": "FallbackPage",
    "data-sentry-source-file": "FallbackPage.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "w-full justify-start items-center gap-4 inline-flex px-5 py-4 bg-white",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "w-6 h-6 relative overflow-hidden cursor-pointer",
        onClick: handleBackClick,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: _arrowLeft.default,
          alt: "Arrow Left",
          style: {
            width: 24,
            height: 24
          }
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "flex-1 flex-col justify-center items-start gap-1 inline-flex",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: "text-[#171715] font-normal uppercase break-words",
          style: {
            fontSize: '12px',
            lineHeight: '14.40px',
            letterSpacing: '2.88px'
          },
          children: fallbackType === 'primary' ? 'Edit Primary Remedy' : "Edit Alternative ".concat(fallbackIndex + 1)
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "flex flex-col h-full overflow-scroll",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_RulesListContainer.default, {
        "data-sentry-element": "RulesListContainer",
        "data-sentry-source-file": "FallbackPage.tsx",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "flex flex-col gap-2 w-full max-w-[500px] box-border mx-auto",
          style: {
            gap: '8px'
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "flex flex-col gap-1",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
              className: "w-[444px] h-[14px] opacity-100 gap-1 pr-2 pl-2 uppercase font-medium text-[#686766]",
              style: {
                fontSize: '12px',
                letterSpacing: '0.24em',
                lineHeight: '120%'
              },
              children: "NAME"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: "w-full max-h-[200px] overflow-y-auto gap-1 opacity-100 rounded-[2px] border-none box-border ".concat(isEditMode ? 'bg-background-primary-canvas' : 'bg-background'),
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
                value: formData.name,
                onChange: function onChange(e) {
                  return handleInputChange('name', e.target.value);
                },
                onFocus: handleFieldFocus,
                placeholder: "Enter fallback name",
                disabled: !canEdit,
                className: "w-full p-2 border-none bg-transparent placeholder:text-[#9CA3AF]",
                style: {
                  fontSize: '16px',
                  letterSpacing: '0.01em'
                }
              })
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "flex flex-col gap-1",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
              className: "w-[444px] h-[14px] opacity-100 gap-1 pr-2 pl-2 uppercase font-medium text-[#686766]",
              style: {
                fontSize: '12px',
                letterSpacing: '0.24em',
                lineHeight: '120%'
              },
              children: "DESCRIPTION"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: "w-full max-h-[200px] overflow-y-auto gap-1 opacity-100 rounded-[2px] border-none box-border ".concat(isEditMode ? 'bg-background-primary-canvas' : 'bg-background'),
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("textarea", {
                value: formData.description,
                onChange: function onChange(e) {
                  return handleInputChange('description', e.target.value);
                },
                onFocus: handleFieldFocus,
                placeholder: "Enter fallback description (optional)",
                rows: 2,
                disabled: !canEdit,
                className: "w-full p-2 border-none bg-transparent resize-none placeholder:text-[#9CA3AF]",
                style: {
                  fontSize: '16px',
                  letterSpacing: '0.01em',
                  lineHeight: '150%'
                }
              })
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "flex flex-row items-center justify-between gap-3",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
              className: "w-[444px] h-[14px] opacity-100 gap-1 pr-2 pl-2 uppercase font-medium text-[#686766]",
              style: {
                fontSize: '12px',
                letterSpacing: '0.24em',
                lineHeight: '120%'
              },
              children: "REMEDY"
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_select.Select, {
              value: formData.remedyType,
              onValueChange: function onValueChange(remedyType) {
                return handleInputChange('remedyType', remedyType);
              },
              disabled: !canEdit,
              "data-sentry-element": "Select",
              "data-sentry-source-file": "FallbackPage.tsx",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_select.SelectTrigger, {
                size: "sm",
                "aria-label": "Remedy type",
                "data-sentry-element": "SelectTrigger",
                "data-sentry-source-file": "FallbackPage.tsx",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_select.SelectValue, {
                  "data-sentry-element": "SelectValue",
                  "data-sentry-source-file": "FallbackPage.tsx",
                  children: getRemedyTypeDisplayText(formData.remedyType)
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_select.SelectContent, {
                position: "popper",
                align: "end",
                "data-sentry-element": "SelectContent",
                "data-sentry-source-file": "FallbackPage.tsx",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_select.SelectItem, {
                  value: "edit_section_tracked",
                  "data-sentry-element": "SelectItem",
                  "data-sentry-source-file": "FallbackPage.tsx",
                  children: "Edit the Section that was found"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_select.SelectItem, {
                  value: "edit_tracked",
                  "data-sentry-element": "SelectItem",
                  "data-sentry-source-file": "FallbackPage.tsx",
                  children: "Edit the Paragraph that was found"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_select.SelectItem, {
                  value: "edit_document_tracked",
                  "data-sentry-element": "SelectItem",
                  "data-sentry-source-file": "FallbackPage.tsx",
                  children: "Edit the document"
                })]
              })]
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "flex flex-col gap-1",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: "w-full max-h-[200px] overflow-y-auto gap-1 opacity-100 rounded-[2px] border-none box-border ".concat(isEditMode ? 'bg-background-primary-canvas' : 'bg-background'),
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("textarea", {
                value: formData.editContent,
                onChange: function onChange(e) {
                  return handleInputChange('editContent', e.target.value);
                },
                onFocus: handleFieldFocus,
                placeholder: "Enter edit content",
                rows: 4,
                disabled: !canEdit,
                className: "w-full p-2 border-none bg-transparent resize-none placeholder:text-[#9CA3AF]",
                style: {
                  fontSize: '16px',
                  letterSpacing: '0.01em',
                  lineHeight: '150%'
                }
              })
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "flex flex-col gap-1",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
              className: "w-[444px] h-[14px] opacity-100 gap-1 pr-2 pl-2 uppercase font-medium text-[#686766]",
              style: {
                fontSize: '12px',
                letterSpacing: '0.24em',
                lineHeight: '120%'
              },
              children: "COMMENT"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: "w-full max-h-[200px] overflow-y-auto gap-1 opacity-100 rounded-[2px] border-none box-border ".concat(isEditMode ? 'bg-background-primary-canvas' : 'bg-background'),
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("textarea", {
                value: formData.comment,
                onChange: function onChange(e) {
                  return handleInputChange('comment', e.target.value);
                },
                onFocus: handleFieldFocus,
                placeholder: "Enter any additional comments (optional)",
                rows: 2,
                disabled: !canEdit,
                className: "w-full p-2 border-none bg-transparent resize-none placeholder:text-[#9CA3AF]",
                style: {
                  fontSize: '16px',
                  letterSpacing: '0.01em',
                  lineHeight: '150%'
                }
              })
            })]
          })]
        })
      })
    }), canEdit && isEditMode && /*#__PURE__*/(0, _jsxRuntime.jsx)(_SaveCancelFooter.default, {
      onSave: handleSave,
      onCancel: handleCancel,
      isSaving: isSaving
    })]
  });
};
var _default = exports.default = FallbackPage;